import { render, staticRenderFns } from "./StudioMedia.vue?vue&type=template&id=71aca89c&scoped=true&"
import script from "./StudioMedia.vue?vue&type=script&lang=js&"
export * from "./StudioMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71aca89c",
  null
  
)

export default component.exports